import { z } from "zod";

export const userChangePinSchema = z.object({
  pin: z
    .string()
    .regex(/^\d{4}$/, "page.register.users.change_pin.pin_error"),
});

export type TUserChangePinForm = z.infer<typeof userChangePinSchema>;
